

export default {
    id:"usePressGesture",
    type:"(options:object):void",
    options:[
        {
            name:"element",type:"HTMLElement",
            description:"gesture target",
        },
        {
            name:"threshold",type:"number",
            description:`
                specifies for how long in milliseconds the element should be pressed to trigger the gesture.
                @Useful to apply long press gestures
                @default to 0
            `,
        },
        {
            name:"timestamp",type:"number",
            description:`
                sets the calling frequency of the onPressing handler in milliseconds
                @default to 0
            `,
        },
        {
            name:"onStart",
            type:"(event:PressEvent):void",
        },
        {
            name:"onPressing",
            type:"(event:PressEvent):void",
        },
        {
            name:"onEnd",
            type:"(event:PressEvent):void",
            props:[{
                name:"PressEvent",
                type:{name:"Event",url:"https://developer.mozilla.org/en-US/docs/Web/API/Event"},
                props:[
                    {
                        name:"duration",
                        type:"number",
                    },
                    {
                        name:"force",
                        type:"number",
                        description:`
                            This is a value between 0.0 (no pressure) and 1.0 
                            (the maximum amount of pressure the hardware can recognize).
                        `,
                    },
                    {
                        name:"cancel",
                        type:"(triggerOnEnd:boolean):void",
                        description:"Cancels the current gesture",
                        props:[{
                            name:"triggerOnEnd",
                            type:"boolean",
                            description:"if true, onEnd will be called, default to true",
                        }],
                    },
                    {
                        name:"remove",
                        type:"():void",
                        description:"Calls cancel and removes the PressEvent listeners",
                    },
                ],
            }],
        },
    ],
}
